import React from 'react'
import { Styling } from './styled.js'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/components/pagination/pagination.min.css"
import Image from './Image'

let windowWidth;

if(typeof window !== 'undefined'){
    windowWidth = window.innerWidth;
}

SwiperCore.use([Autoplay, Navigation, Pagination]);


export default function ImageSlider({images, gallery}) {
    return (
        <Styling>
             <Swiper 
                slidesPerView={1}  
                spaceBetween={10} 
                breakpoints={{
                    "640": {
                      "slidesPerView": 1,
                      "spaceBetween": 10
                    },
                    "768": {
                      "slidesPerView": 1.5,
                      "spaceBetween": 10
                    },
                    "1024": {
                      "slidesPerView": 2.5,
                      "spaceBetween": 10
                    }
                  }}
                className="swipe-slider" 
                navigation={true}
                pagination={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false
                }}>
                 {
                    images.map((slide, index) => {
                        return (
                            <SwiperSlide key={'swiper_'+index}>
                                <Image theImage={slide.image.localFile} gallery={gallery} />
                            </SwiperSlide>
                        )
                    })
                 }
            </Swiper>     
        </Styling>
    )
}
